import $ from 'jquery';
import URI from 'urijs';
import * as infiniteHits from './load_more_results';
import { showModalFromUrl, initializeSaveSearch } from './search_helpers';

window.CompaniesGridView = {
  _searchObject: {},

  initializeWidgets(user_id, app_id, key, index, location, activity, tag, userTag, sortByIndices) {
    const searchParameters = {};

    if (activity || location || userTag) {
      const tagAttributeName = `user_tags.${user_id}`;
      searchParameters['facets'] = ['state', 'secondary_activities', 'locations', tagAttributeName];
      searchParameters['facetsRefinements'] = { secondary_activities: [activity], locations: [location] };
      searchParameters['facetsRefinements'][tagAttributeName] = [userTag];
    }

    this._searchObject = SearchUtils.createInstantSearch(app_id, key, index);

    // Build widgets array (v4: use addWidgets instead of deprecated addWidget)
    searchParameters.filters = Widgets.getCompaniesQuery(user_id, tag);
    const widgets = [
      instantsearch.widgets.configure(searchParameters),
      Widgets.companiesGridHitsWidget(user_id),
      Widgets.descriptionWidget(),
      Widgets.primaryActivitiesWidget(),
      Widgets.secondaryActivitiesWidget(),
      Widgets.currentRefinedValuesWidget()({ excludedAttributes: [] }),
      Widgets.statsWidget(),
      Widgets.searchBoxWidget(I18n.t('projects.keyword_filter.enter_keyword')),
      Widgets.locationWidget(),
      Widgets.quickListWidget(),
      Widgets.clearAllWidget(),
      Widgets.sortBySelectorWidget(sortByIndices),
      Widgets.saveSearchWidget()
    ];

    if ($('#user-tags').length > 0) { widgets.push(Widgets.userTagsWidget(user_id)); }
    if ($('#projects-location').length > 0) { widgets.push(Widgets.projectsLocationWidget()); }
    if ($('#sectors').length > 0) { widgets.push(Widgets.projectsMainSectorWidget()); }
    if ($('#sectors').length > 0) { widgets.push(Widgets.projectsSectorWidget()); }
    if ($('#budget-range').length > 0) { widgets.push(Widgets.projectsBudgetWidget()); }
    if ($('#projects-count').length > 0) { widgets.push(Widgets.projectsCountWidget()); }
    if ($('#team-size').length > 0) { widgets.push(Widgets.teamSizeWidget()); }
    if ($('#certificates').length > 0) { widgets.push(Widgets.certificatesWidget()); }

    this._searchObject.addWidgets(widgets);
    this._searchObject.start();

    infiniteHits.loadMoreResults();

    this._initializeSaveSearch();

    this._searchObject.on('render', function () {
      if (user_id) { SearchUtils.adjustViewMode(); }
      $.cloudinary.responsive();
      if (!$('html').is('.platform-layout')) {
        // Always destroy the existing grid before re-initializing so savvior
        // recalculates column dimensions against the new result set.
        // Previously this path was unreachable due to $.cloudinary.responsive()
        // throwing — masking a latent bug where destroy() was called without
        // a subsequent setup_gridview().
        if (savvior.ready(".ais-Hits-list")) {
          savvior.destroy();
        }
        setup_gridview();
        return;
      }
    });

    return SearchUtils.setUpCustomListsLink('#quick-lists li > .all_list, .liked_list');
  },

  _initializeSaveSearch() {
    initializeSaveSearch({ type: 'public_companies', showSignInModal: true });
  }
};
